import { Hauler } from './hauler.model';
import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { seeds } from '../seeds/seeds';
import { AuthService } from '../auth/auth.service';
import { Http } from '@angular/http';
import { GeoService } from '../shared/geo.service';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';


@Injectable()
export class HaulersService {
    haulersChanged = new Subject<Hauler[]>();

    itemsCollection: AngularFirestoreCollection<any>;
    items: Observable<any[]>;


    private haulersUrl = 'https://salto-25b3e.firebaseio.com/haulers.json?auth=';

    private haulers: Hauler[] = seeds.haulers;
    // private haulers: Hauler[];


    constructor(private afs: AngularFirestore, private authService: AuthService, private http: Http, private geoService: GeoService) {
    }

    getItems() {
        return this.afs.collection('haulers')
        .snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
            });
        });
    }

    addItem(item: any): Promise<any> {
        return this.afs.collection('haulers').add(item);
      }

    getItem(id: string) {
        return this.afs.doc(`haulers/${id}`).valueChanges();
    }

    updateItem(id: string, data: Partial<any>): Promise<void> {
        return this.afs.doc(`haulers/${id}`).update(data);
    }

    removeItem(id: string): Promise<void> {
        return this.afs.doc(`haulers/${id}`).delete();
    }

    // getItem(id: string) {
    //     const itemPath =  `${this.haulersUrl}/${id}`;
    //     this.item = this.db.object(itemPath).valueChanges();
    //     return this.item;
    //   }

      // Default error handling for all actions
        private handleError(error) {
        console.log(error);
        }


    getHaulers() {
        // const token = this.authService.getToken();
        // return this.http.get(this.haulersUrl + token);
        return this.haulers.slice();
    }

    getHauler(id: string) {
       return this.haulers.find(function(element) {
            return element['_id'] === id;
          });
    }

    addHauler(hauler: Hauler) {
        this.haulers.push(hauler);
        this.haulersChanged.next(this.haulers.slice());
        const token = this.authService.getToken();
        return this.http.post(this.haulersUrl + token, hauler);

    }

    // updateHauler(id: string, newHauler: Hauler) {
    //     let updateHauler = this.haulers.find(function(element) {return element['_id'] === id; });
    //     let index = this.haulers.indexOf(updateHauler);
    //     this.haulers[index] = newHauler;
    //     this.haulersChanged.next(this.haulers.slice());
    // }

    // deleteHauler(id: string) {
    //     this.haulers = this.haulers.filter(function(obj) {return obj._id !== id; } );
    //     this.haulersChanged.next(this.haulers.slice());
    // }


}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers.service.ts